import React from 'react'
import { Link } from 'react-router-dom'
import cloneDeep from 'lodash/cloneDeep'
import * as JsSearch from 'js-search'

import { filterPresets } from '@modules/form/form.module'
import LocalDataTable from '@components/LocalDataTable/LocalDataTable'
import jobStatuses from '@server/constants/statuses/job-statuses'
import matchedCandidateStatuses from '@server/constants/statuses/matched-candidate-statuses'

const TableRowLink = ({children, ...props}) => {
	return props.to
		? <Link className="TableRow-link btn btn-primary" {...props}>{children}</Link>
		: <button className="TableRow-link btn btn-primary" type="button" {...props}>{children}</button>;
}

const compareStrings = (sortDir, a, b) => {
	if(a > b)
		return sortDir === 'asc' ? 1 : -1
	if(a < b)
		return sortDir === 'asc' ? -1 : 1;
	return 0;
}

const compareNumbers = (sortDir, a, b) => {
	return sortDir === 'asc'
		? a - b
		: b - a
}

export default 
class MatchedCandidates extends React.Component {

	getTableConfig(isEditing) {
		
		var tableConfig = {
			columns: [
				{
					label: 'Payroll No.',
					sortKey: 'payrollNo',
					getValue: match => match.candidate.payrollNo,
					sortHandler: (sortDir, a, b) => {
						if(sortDir === 'asc')
							return a.candidate.payrollNo - b.candidate.payrollNo
						else if(sortDir === 'desc')
							return b.candidate.payrollNo - a.candidate.payrollNo;
					}
				},
				{
					label: 'Status',
					sortKey: 'status',
					getValue: match => match.status.label,
					sortHandler: (sortDir, a, b) => {
						const res = compareNumbers(sortDir, a.status.order, b.status.order)
						return res;
					}
				},
				// TODO: change status/role to "access"
				{
					label: 'Name',
					sortKey: 'name',
					getValue: function(match) {
						return `${match.candidate.name.first} ${match.candidate.name.last}`;
					},
					sortHandler: (sortDir, a, b) => {
						const makeFullName = candidate => `${candidate.name.first.toUpperCase()} ${candidate.name.last.toUpperCase()}`;
						return compareStrings(sortDir, makeFullName(a.candidate), makeFullName(b.candidate));
					}
				},
				{
					label: 'Email Address',
					sortKey: 'email',
					getValue: match => match.candidate.email,
					sortHandler: (sortDir, a, b) => compareStrings(sortDir, a.candidate.email, b.candidate.email),
				},
			],
			filters: [
				...filterPresets([
					['status', {
						options: [
							{ label: 'All', value: 'any' },
							...matchedCandidateStatuses.map(s => ({
								label: s.label,
								value: s.order,
							})),
						],
						filterHandler: (data, filterValue) => 
							data.filter(match => match.status.order === filterValue),
					}],
					// 'payrollNo',
					['search', {
						placeholder: 'Payroll No. / Name / E-mail Address',
						filterHandler: (data, filterValue) => {
							const candidateSearch = new JsSearch.Search('id');
							candidateSearch.addIndex(['candidate', 'email']);
							candidateSearch.addIndex(['candidate', 'name', 'first']);
							candidateSearch.addIndex(['candidate', 'name', 'last']);
							candidateSearch.addIndex(['candidate', 'payrollNo']);

							candidateSearch.addDocuments(data);

							return candidateSearch.search(filterValue);
						}
					}],
				]),
			]
		}

		if(isEditing) {
			tableConfig.rowLinks = (row) => {
				const id = row.candidate._id;
				const viewLink = <TableRowLink target="_blank" to={`/candidate/${id}`}>view</TableRowLink>;

				switch(row.status.key) {
					case 'notInterviewed':
						return (
							<div>
								{viewLink}
								<TableRowLink onClick={this.getHandler('interviewBooked', id)}>booked</TableRowLink>
							</div>
						)
					case 'pending':
						return (
							<div>
								{viewLink}
								<TableRowLink onClick={this.getHandler('interviewSuccess', id)}>successful</TableRowLink>
								<TableRowLink onClick={this.getHandler('interviewFail', id)}>unsuccessful</TableRowLink>
							</div>
						)
					default:
						return '';
				}
			};
		}

		return tableConfig;
	}

	getHandler(func, id) {
		return (e) => {
			e.preventDefault();
			this[func](id);
		}
	}

	setRowStatusById(id, status) {
		const { form, field } = this.props;

		var value = cloneDeep(field.value);

		for(let i = 0; i < value.length; i++) {
			if(value[i].candidate._id === id) {
				value[i].status = status;
				break;
			}
		}

		form.setFieldValue('matchedCandidates', value)
	}

	interviewBooked(id) {
		const { form } = this.props;
		// set job status to interviewing
		form.setFieldValue('status', jobStatuses.find(s => s.key === 'interviewing'));
		// set candidate match status to pending
		this.setRowStatusById(id, matchedCandidateStatuses.find(s => s.key === 'pending'));
	}

	interviewSuccess(id) {
		var { field, form } = this.props;
		
		// set job status to position-filled
		form.setFieldValue('status', jobStatuses.find(s => s.key === 'position-filled'));

		// set successful match
		// set all pending to unsuccessful
		var value = cloneDeep(field.value);

		for(let i = 0; i < value.length; i++) {
			if(value[i].candidate._id === id) {
				value[i].status = matchedCandidateStatuses.find(s => s.key === 'successful');
			} 
			else if (value[i].status.key === 'pending') {
				value[i].status = matchedCandidateStatuses.find(s => s.key === 'unsuccessful');
			}
		}

		form.setFieldValue('matchedCandidates', value)

	}

	interviewFail(id) {
		// set candidate match status to unsuccessful
		this.setRowStatusById(id, matchedCandidateStatuses.find(s => s.key === 'unsuccessful'));
	}

	render() {
		const { field, isEditing } = this.props;
		var tableConfig = this.getTableConfig(isEditing);

		return (
			<div className="MatchedCandidates">
				<LocalDataTable 
					{...tableConfig} 
					isEditing={isEditing}
					showRowLinks={isEditing}
					data={field.value}
				/>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/modules/form/components/input/MatchedCandidates.jsx